document.addEventListener('DOMContentLoaded', function () {
  initRevelado();
  initHeaderSticky();
  initMenuMovil();
  initGaleriaProducto();
  initGaleriaAutoRotar();
  initVariantesProducto();
  initHeroSlider();
  initBarraFijaCompra();
  initModales();
  initPopupBienvenida();
  initBotonArriba();
  initAcordeonProducto();
  initVideoSeccion();
  initComprarAhora();
  initVibracionAgregarCarrito();
  initVibracionAmbienteTarjetas();
});

function initVibracionAmbienteTarjetas() {
  var botones = document.querySelectorAll('.quick-add__submit');
  if (!botones.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var enPantalla = function (boton) {
    var r = boton.getBoundingClientRect();
    return r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
  };

  setInterval(function () {
    botones.forEach(function (boton) {
      if (boton.disabled || boton.getAttribute('aria-disabled') === 'true') return;
      if (!enPantalla(boton)) return;
      boton.classList.remove('tz-vibrar-suave');
      void boton.offsetWidth;
      boton.classList.add('tz-vibrar-suave');
      boton.addEventListener('animationend', function () {
        boton.classList.remove('tz-vibrar-suave');
      }, { once: true });
    });
  }, 3000);
}

function initVibracionAgregarCarrito() {
  var vibrarBoton = function (boton) {
    if (!boton || boton.getAttribute('aria-disabled') === 'true' || boton.disabled) return;

    boton.classList.remove('tz-vibrar');
    void boton.offsetWidth;
    boton.classList.add('tz-vibrar');
    boton.addEventListener('animationend', function () {
      boton.classList.remove('tz-vibrar');
    }, { once: true });

    if (window.navigator && typeof window.navigator.vibrate === 'function') {
      try { window.navigator.vibrate(35); } catch (e) {}
    }
  };

  document.addEventListener('click', function (evento) {
    var boton = evento.target.closest('button[name="add"], [data-sticky-add]');
    vibrarBoton(boton);
  });
}

function initComprarAhora() {
  document.addEventListener('click', function (evento) {
    var boton = evento.target.closest('[data-tz-comprar-ahora]');
    if (!boton || boton.getAttribute('aria-disabled') === 'true' || boton.disabled) return;

    var formulario = boton.closest('form');
    if (!formulario || !window.routes || !window.routes.cart_add_url) return;

    evento.preventDefault();
    boton.setAttribute('aria-disabled', 'true');
    boton.classList.add('loading');
    var spinner = boton.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    var datos = new FormData(formulario);

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: datos
    })
      .then(function (respuesta) { return respuesta.json(); })
      .then(function (respuesta) {
        if (respuesta.status) {
          boton.removeAttribute('aria-disabled');
          boton.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
          return;
        }
        var urlCarrito = (window.routes.cart_url || '/cart').replace(/\/cart\/?$/, '/checkout');
        window.location.href = urlCarrito;
      })
      .catch(function () {
        boton.removeAttribute('aria-disabled');
        boton.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      });
  });
}

function initBotonArriba() {
  var boton = document.querySelector('[data-tz-boton-arriba]');
  if (!boton) return;

  var actualizar = function () {
    var visible = window.scrollY > window.innerHeight * 0.6;
    boton.hidden = false;
    boton.classList.toggle('tz-visible', visible);
  };
  actualizar();
  window.addEventListener('scroll', actualizar, { passive: true });

  boton.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

function initPopupBienvenida() {
  var popup = document.querySelector('[data-tz-popup="bienvenida"]');
  if (!popup) return;

  var cerrar = function () {
    popup.hidden = true;
    document.body.style.overflow = '';
    try { sessionStorage.setItem('tz_popup_bienvenida_visto', '1'); } catch (e) {}
  };

  popup.querySelectorAll('[data-tz-popup-cerrar]').forEach(function (el) {
    el.addEventListener('click', cerrar);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !popup.hidden) cerrar();
  });

  var yaVisto = false;
  try { yaVisto = sessionStorage.getItem('tz_popup_bienvenida_visto') === '1'; } catch (e) {}
  if (yaVisto) return;

  setTimeout(function () {
    popup.hidden = false;
    document.body.style.overflow = 'hidden';
  }, 6000);
}

function initModales() {
  var triggers = document.querySelectorAll('[data-tz-modal-abrir]');
  if (!triggers.length) return;

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var id = trigger.getAttribute('data-tz-modal-abrir');
      var modal = document.querySelector('[data-tz-modal="' + id + '"]');
      if (!modal) return;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    });
  });

  document.querySelectorAll('[data-tz-modal]').forEach(function (modal) {
    modal.querySelectorAll('[data-tz-modal-cerrar]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.hidden = true;
        document.body.style.overflow = '';
      });
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-tz-modal]:not([hidden])').forEach(function (modal) {
        modal.hidden = true;
        document.body.style.overflow = '';
      });
    }
  });
}

function initBarraFijaCompra() {
  var barra = document.querySelector('[data-tz-sticky-bar]');
  if (!barra) return;
  var botonesPrincipales = document.querySelector('.tz-producto__botones');
  if (!botonesPrincipales) return;

  var botonPrincipal = document.querySelector('.tz-producto__btn-carrito');
  var botonSticky = barra.querySelector('[data-tz-sticky-comprar]');
  if (botonSticky && botonPrincipal) {
    botonSticky.addEventListener('click', function () {
      botonPrincipal.click();
    });
  }

  if (!('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var visible = !entry.isIntersecting;
        barra.classList.toggle('tz-visible', visible);
        if (visible) {
          document.documentElement.style.setProperty('--tz-barra-fija-alto', barra.offsetHeight + 'px');
        }
        document.body.classList.toggle('tz-tiene-barra-fija', visible);
      });
    },
    { threshold: 0 }
  );
  observer.observe(botonesPrincipales);
}

function initHeroSlider() {
  var heroes = document.querySelectorAll('[data-tz-hero-slider]');
  heroes.forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-tz-hero-slide]');
    if (slides.length < 2) return;
    var puntos = hero.querySelectorAll('[data-tz-hero-punto]');
    var actual = 0;
    var velocidad = Number(hero.dataset.tzVelocidad) || 5000;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var mostrar = function (indice) {
      slides[actual].classList.remove('tz-activo');
      if (puntos[actual]) puntos[actual].classList.remove('tz-activo');
      actual = indice;
      slides[actual].classList.add('tz-activo');
      if (puntos[actual]) puntos[actual].classList.add('tz-activo');
    };

    var siguiente = function () { mostrar((actual + 1) % slides.length); };

    puntos.forEach(function (punto, i) {
      punto.addEventListener('click', function () { mostrar(i); reiniciarIntervalo(); });
    });

    var intervalo;
    var reiniciarIntervalo = function () {
      clearInterval(intervalo);
      if (!reducedMotion) intervalo = setInterval(siguiente, velocidad);
    };
    reiniciarIntervalo();
  });
}

function initRevelado() {
  var elementos = document.querySelectorAll('.tz-reveal, .tz-reveal-scale');
  if (!elementos.length) return;

  if (!('IntersectionObserver' in window)) {
    elementos.forEach(function (el) { el.classList.add('tz-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.dataset.tzDelay || 0;
          setTimeout(function () { entry.target.classList.add('tz-visible'); }, Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  elementos.forEach(function (el) { observer.observe(el); });
}

function initHeaderSticky() {
  var header = document.querySelector('.tz-header');
  if (!header) return;
  var onScroll = function () {
    header.classList.toggle('tz-header--scrolled', window.scrollY > 8);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

function initMenuMovil() {
  var burger = document.querySelector('[data-tz-menu-abrir]');
  var menu = document.querySelector('[data-tz-menu]');
  var overlay = document.querySelector('[data-tz-menu-overlay]');
  var cerrar = document.querySelector('[data-tz-menu-cerrar]');
  if (!burger || !menu) return;

  var abrir = function () {
    menu.classList.add('tz-open');
    if (overlay) overlay.classList.add('tz-open');
    document.body.style.overflow = 'hidden';
  };
  var cerrarMenu = function () {
    menu.classList.remove('tz-open');
    if (overlay) overlay.classList.remove('tz-open');
    document.body.style.overflow = '';
  };

  burger.addEventListener('click', abrir);
  if (cerrar) cerrar.addEventListener('click', cerrarMenu);
  if (overlay) overlay.addEventListener('click', cerrarMenu);
  menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', cerrarMenu); });
}

function initGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-tz-galeria]');
  galerias.forEach(function (galeria) {
    var panels = galeria.querySelectorAll('[data-tz-galeria-panel]');
    var thumbs = galeria.querySelectorAll('[data-tz-galeria-thumb]');
    if (!panels.length || !thumbs.length) return;

    var pausarMedia = function (panel) {
      var video = panel.querySelector('video');
      if (video) video.pause();
      var iframe = panel.querySelector('iframe');
      if (iframe) iframe.src = iframe.src;
    };

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaId = thumb.getAttribute('data-media-id');
        if (!mediaId) return;

        panels.forEach(function (panel) {
          var esActivo = panel.getAttribute('data-media-id') === mediaId;
          if (!esActivo) pausarMedia(panel);
          panel.classList.toggle('tz-activo', esActivo);
        });
        thumbs.forEach(function (t) { t.classList.remove('tz-activo'); });
        thumb.classList.add('tz-activo');
      });
    });
  });
}

function initGaleriaAutoRotar() {
  // Cambia de imagen sola cada 25s en la galería de la página de
  // producto. Usa el botón nativo "siguiente" del slider (el mismo que
  // pulsa un cliente a mano), en vez de la API setActiveMedia de Dawn:
  // esa API asume que existe una miniatura para cada imagen, pero en
  // celular las miniaturas están ocultas (mobile_thumbnails: hide) y no
  // existen en el DOM, así que setActiveMedia truena ahí. El botón
  // "siguiente" funciona igual en escritorio y celular.
  var INTERVALO = 25000;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.querySelectorAll('media-gallery').forEach(function (galeria) {
    var visor = galeria.querySelector('[id^="GalleryViewer"]');
    var slider = visor && visor.querySelector('[id^="Slider-Gallery"]');
    var botonSiguiente = visor && visor.querySelector('button[name="next"]');
    if (!visor || !slider || !botonSiguiente) return;

    setInterval(function () {
      if (document.hidden) return;

      // Solo avanza si la galería se está viendo; si el cliente ya bajó por la
      // página no se toca nada (así no lo regresa arriba mientras lee).
      var caja = visor.getBoundingClientRect();
      if (caja.bottom < 0 || caja.top > window.innerHeight) return;

      var hayVideoReproduciendo = false;
      slider.querySelectorAll('video').forEach(function (video) {
        if (!video.paused && !video.ended) hayVideoReproduciendo = true;
      });
      if (hayVideoReproduciendo) return; // no interrumpir un video que el cliente está viendo

      // Solo rota entre las IMÁGENES. Nunca entra solo a un video: si la
      // siguiente es un video (o ya no hay más), regresa a la primera
      // imagen; y si el cliente está parado en un video, no se mueve nada
      // (los videos solo se ven cuando el cliente va a ellos).
      var slides = Array.prototype.slice.call(slider.querySelectorAll('.slider__slide'));
      var izquierda = slider.getBoundingClientRect().left;
      var actual = 0;
      var menorDistancia = Infinity;
      slides.forEach(function (slide, i) {
        var distancia = Math.abs(slide.getBoundingClientRect().left - izquierda);
        if (distancia < menorDistancia) { menorDistancia = distancia; actual = i; }
      });
      var esVideo = function (slide) { return !!(slide && slide.querySelector('.media-type-video, video, deferred-media')); };
      if (esVideo(slides[actual])) return;

      var siguiente = slides[actual + 1];
      if (!siguiente || esVideo(siguiente)) {
        slider.scrollTo({ left: 0, behavior: 'smooth' }); // última imagen: vuelve a la primera
      } else {
        botonSiguiente.click();
      }
    }, INTERVALO);
  });
}

function initVariantesProducto() {
  var forms = document.querySelectorAll('[data-tz-variantes]');
  forms.forEach(function (wrapper) {
    var dataEl = wrapper.querySelector('[data-tz-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var selects = wrapper.querySelectorAll('[data-tz-opcion]');
    var idInput = wrapper.querySelector('[data-tz-variant-id]');
    var precioEl = wrapper.querySelector('[data-tz-precio]');
    var precioAntesEl = wrapper.querySelector('[data-tz-precio-antes]');
    var submitBtn = wrapper.querySelector('[data-tz-submit]');
    var submitTexto = submitBtn ? submitBtn.querySelector('span') : null;
    var disponibleTexto = wrapper.dataset.tzTextoDisponible || 'Agregar al carrito';
    var agotadoTexto = wrapper.dataset.tzTextoAgotado || 'Agotado';

    var formatMoney = function (cents) {
      return '$' + (cents / 100).toFixed(2);
    };

    var actualizar = function () {
      var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;

      if (idInput) idInput.value = variante.id;
      if (precioEl) precioEl.textContent = formatMoney(variante.price);
      if (precioAntesEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAntesEl.textContent = formatMoney(variante.compare_at_price);
          precioAntesEl.style.display = '';
        } else {
          precioAntesEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        if (variante.available) {
          submitBtn.removeAttribute('aria-disabled');
          submitBtn.removeAttribute('disabled');
          if (submitTexto) submitTexto.textContent = disponibleTexto;
        } else {
          submitBtn.setAttribute('aria-disabled', 'true');
          submitBtn.setAttribute('disabled', 'disabled');
          if (submitTexto) submitTexto.textContent = agotadoTexto;
        }
      }
    };

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  });
}

function initVideoSeccion() {
  document.querySelectorAll('[data-tz-video-marco]').forEach(function (marco) {
    var boton = marco.querySelector('[data-tz-video-sonido]');
    if (!boton) return;

    var video = marco.querySelector('[data-tz-video-nativo] video');
    var iframe = marco.querySelector('[data-tz-video-iframe]');
    var plataforma = marco.querySelector('[data-tz-video-embed]');
    plataforma = plataforma ? plataforma.getAttribute('data-plataforma') : null;

    boton.addEventListener('click', function () {
      var activar = !boton.classList.contains('tz-activo');
      boton.classList.toggle('tz-activo', activar);
      boton.setAttribute('aria-label', activar ? 'Silenciar' : 'Activar sonido');

      if (video) {
        video.muted = !activar;
        if (activar) video.play().catch(function () {});
      } else if (iframe) {
        if (plataforma === 'youtube') {
          iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: activar ? 'unMute' : 'mute', args: [] }), '*');
        } else {
          iframe.contentWindow.postMessage(JSON.stringify({ method: 'setVolume', value: activar ? 1 : 0 }), '*');
        }
      }
    });
  });
}

function initAcordeonProducto() {
  document.querySelectorAll('[data-tz-acordeon]').forEach(function (acordeon) {
    var items = acordeon.querySelectorAll('[data-tz-acordeon-item]');

    var cerrar = function (item) {
      var toggle = item.querySelector('[data-tz-acordeon-toggle]');
      var panel = item.querySelector('[data-tz-acordeon-panel]');
      item.classList.remove('tz-activo');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (panel) panel.style.maxHeight = '0px';
    };

    var abrir = function (item) {
      var toggle = item.querySelector('[data-tz-acordeon-toggle]');
      var panel = item.querySelector('[data-tz-acordeon-panel]');
      item.classList.add('tz-activo');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
    };

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-tz-acordeon-toggle]');
      var panel = item.querySelector('[data-tz-acordeon-panel]');
      if (!toggle || !panel) return;

      if (item.classList.contains('tz-activo')) {
        requestAnimationFrame(function () { panel.style.maxHeight = panel.scrollHeight + 'px'; });
      } else {
        panel.style.maxHeight = '0px';
      }

      toggle.addEventListener('click', function () {
        var estabaAbierto = item.classList.contains('tz-activo');
        items.forEach(cerrar);
        if (!estabaAbierto) abrir(item);
      });
    });

    window.addEventListener('resize', function () {
      var activo = acordeon.querySelector('[data-tz-acordeon-item].tz-activo [data-tz-acordeon-panel]');
      if (activo) activo.style.maxHeight = activo.scrollHeight + 'px';
    });
  });
}
